define('app/views/travel_hotel_offline_checkout_view',['app/setup'],

  function(takhfifan) {
    takhfifan.hotelOfflineCheckout = Backbone.View.extend({
      events: {
        'submit .tkh-travel-hotel-passengers-form' : 'submitForm',
        'click .tkh-travel-checkout__action-edit': 'enablePassengerForm',
        'click .tkh-payment-item': 'selectPaymentMethod',
        'click .tkh-travel-checkout__action-pay': 'saveOrder'
      },

      initialize: function () {
        this.saveOrderPath = this.$el.data('saveOrderUrl');
        this.paymentMethodsPath = this.$el.data('paymentMethodsUrl');
        this.savePaymentMethodsPath = this.$el.data('savePaymentMethodsUrl');
        this.$errorMessage = this.$el.find('.tkh-travel-checkout-error-message');

        this.initForm();

        $(document).on('change invalid','.tkh-travel-form-input', function() {
          if($(this).prop('type')==='radio'){
            return;
          }
          var inputField = $(this).get(0);

          inputField.setCustomValidity('');

          if (!inputField.validity.valid) {
            var fieldName = $(this).prop('placeholder');
            inputField.setCustomValidity('لطفا ' + fieldName + ' را وارد کنید');
          }
        });

        var _this = this;
        takhfifan.eventHub.on('travelPayment:success', function () {
          setTimeout(redirectToBankUrl, 2000);
          _this.redirecting = false;

          function redirectToBankUrl() {
            if (!_this.redirecting) {
              window.location.replace(_this.$el.data('success-path'));
              _this.redirecting = true;
            }
          }
        }, this);

      },

      initForm: function () {
        this.persistedData = this.$el.data('travelHotelData');
        var dataUpdatedTime = (this.persistedData && this.persistedData.time) || undefined;

        if(!this.persistedData){
          this.showFailedCart();
          return;
        }

        if (this.persistedData.hasOwnProperty('error')) {
          var message= null;
          switch (this.persistedData.error) {
            case 'expired': message = 'مشتری گرامی زمان شما برای پرداخت این رزرو به پایان رسیده است. لطفا در صورت تمایل مجدد درخواست خود را ثبت  نمایید';break;
            case 'notFound':message= "مشتری گرامی رزروی  با مشخصات درخواستی شما یافت نشد" ;break;
            case 'state': message= "مشتری گرامی رزرو شما در حالت تایید اولیه نمی باشد." ;break;
          }
          this.showFailedCart(message);
          takhfifan.eventHub.trigger('offline_passenger:error', 'show form:' + this.persistedData.error);
          return;
        }else if(!this.persistedData.hotels || !this.persistedData.search || !this.persistedData.cart || !this.persistedData.time){
          this.showFailedCart();
          takhfifan.eventHub.trigger('offline_passenger:error', 'loading Info: unknown');
          return;
        }

        if(dataUpdatedTime){
          var currentTime = new Date();
          if(currentTime - this.persistedData.time > 15*60*1000){
            this.persistedData = null;
            this.showFailedCart();
            return;
          }
        }

        this.$el.find('.tkh-hotel-loader').hide();
        this.$el.find('.tkh-travel-checkout-wrapper').show();
      },

      showFailedCart: function(message){
        this.$errorMessage.text(message ? message : 'سبد شما خالی است.' );
        this.$el.find('.tkh-hotel-loader').hide();
        this.$el.find('.tkh-travel-checkout-block-error').show();
      },

      getPaymentMethods: function () {
        var _this = this;
        $.ajax({
          type: 'POST',
          url: _this.paymentMethodsPath,
          data: {form_key: takhfifan.formKey}
        }).done(function (data) {
          data = JSON.parse(data);
          _this.initConfirmView(data.payment_methods);
        }).fail(function () {
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: 'عملیات با خطا مواجه شد.'
          });
          _this.showFailedCart('در برقراری ارتباط با سرور مشکلی پیش آمد. لطفا مجددا جستجو کنید');
          takhfifan.eventHub.trigger('offline_passenger:error', 'get payment methods');
        }).complete(function(){
          _this.enable()
        });
      },

      submitForm: function (e) {
        e.preventDefault();
        this.disable();
        var formData = this.gatherPassengersData();
        var _this = this;
        $.ajax({
          type: 'POST',
          url: _this.saveOrderPath,
          data: formData
        }).done(function (data) {
          if (!data || !data.success) {
            var message = data && data.message ? data.message :'';
            takhfifan.eventHub.trigger('message:show', {
                type: 'error',
                msg: message ||  "خطایی در برقراری ارتباط پیش آمد."
              });
             _this.enable();
             _this.showFailedCart(message || 'در برقراری ارتباط با سرور مشکلی پیش آمد. لطفا مجددا اطلاعات را وارد کنید');
            takhfifan.eventHub.trigger('offline_passenger:error', 'submit passenger form :' + (message || 'unknown'));
          } else {
            _this.disablePassengerForm();
            _this.getPaymentMethods();
            if(data.data.total_price){
              _this.updatePrice(data.data.total_price)
            }
          }
        }).fail(function () {
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: 'عملیات با خطا مواجه شد.'
          });
          _this.showFailedCart('در برقراری ارتباط با سرور مشکلی پیش آمد. لطفا مجددا جستجو کنید');
          _this.enable();
          takhfifan.eventHub.trigger('offline_passenger:error', 'submit passenger form: connection');
        }).complete(function(){
          _this.enable()
        });

        e.preventDefault();
        _this.disable();

      },

      updatePrice: function (totalPrice) {
        var $priceHolder = $('.tkh-travel-price');
        $priceHolder.html(this.formatPrice(totalPrice));
        $priceHolder.css('color','#ff5a5f');
        $('html, body').animate({
          scrollTop: $priceHolder.offset().top - 150
        }, 500);
      },

      disablePassengerForm : function () {
        var $form = this.$('.tkh-travel-hotel-passengers-form');
        $form.find(':input').each(function(){
          $(this).prop("disabled","disabled");
        });
        this.$('.tkh-travel-checkout__action-back').hide();
        this.$('.tkh-travel-checkout__action-submit').hide();
        this.$('.tkh-travel-checkout__action-edit').show();
        this.$('.tkh-travel-checkout__action-pay').show();
      },

      enablePassengerForm: function () {
        var $form = this.$('.tkh-travel-hotel-passengers-form');
        $form.find(':input').each(function(){
          $(this).removeAttr("disabled");
        });
        // $('.datepicker-container').removeClass('force-hide');
        this.$('.tkh-travel-checkout__action-edit').hide();
        this.$('.tkh-travel-checkout__action-pay').hide();
        this.$('.tkh-travel-checkout__action-back').show();
        this.$('.tkh-travel-checkout__action-submit').show();
        this.$('.tkh-travel-checkout__payments').html('');
        this.paymentMethod = "";
      },

      gatherPassengersData: function () {
        if(this.persistedData) {

          var data = {
            formKey: takhfifan.formKey,
            firstname: this.$('input[name="firstName"]').val(),
            lastname: this.$('input[name="lastName"]').val(),
            email: this.$('input[name="email"]').val(),
            mobile: this.$('input[name="mobile"]').val(),
            tel: this.$('input[name="tel"]').val(),
            hotelId: this.persistedData.cart.hotelId,
            hotelName: this.persistedData.cart.hotelName,
            hotelAddress: this.persistedData.cart.hotelAddress,
            checkin: this.persistedData.search.checkin,
            night: this.persistedData.search.nights,
            reservation_id: this.getReservationId()
          };

          data['passenger'] = [];
          this.$('.tkh-travel-checkout-passenger').each(function (index) {
            var $pData = $(this);
            data['passenger'].push({
              // "type": $pData.find('[name^="type"]:checked').val(),
              "roomId": $pData.find('[name^="roomId"]').val(),
              "roomName": $pData.find('[name^="roomName"]').val(),
              "extraBedNo": $pData.find('[name^="extraBedNo"]').val(),
              "name": $pData.find('[name^="name"]').val(),
              "family": $pData.find('[name^="family"]').val(),
              "mobile": $pData.find('[name^="mobile"]').val(),
              "idNo": $pData.find('[name^="idNo"]').val(),
              "childNo": $pData.find('[name^="childNo"]').val(),
              "infantNo": $pData.find('[name^="infantNo"]').val(),
              "description": $pData.find('[name^="description"]').val()
            });
          });
          return data;
        }
        return [];
      },

      getReservationId: function()
      {
        if (offlineHotelReservationId) {
          return offlineHotelReservationId;
        }
        var url_string = window.location.href;
        var url        = new URL(url_string);
        return url.searchParams.get('reservation_id');
      },

      initConfirmView:function (paymentMethods) {
        var template = _.template($("#travel-payment-methods").html()),
            compiled_template = template({payment_methods:paymentMethods});
        this.$('.tkh-travel-checkout__payments').html(compiled_template);
        var $firstMethod = $('.tkh-travel-checkout__payments .tkh-payment-item').first();
        $firstMethod.addClass('active');
        this.savePaymentMethod($firstMethod.data("method"));
      },

      formatPrice: function (x) {
        return parseInt(x / 10, 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "،") + " تومان";
      },

      selectPaymentMethod: function(e) {
        var $target = $(e.currentTarget);
        $target.parent('.tkh-travel-checkout__payments').find('.active').removeClass('active');
        $target.addClass('active');
        this.savePaymentMethod($target.data("method"))
      },

      savePaymentMethod: function (method) {
        var _this = this;
        this.$('.tkh-travel-checkout__action-pay').prop('disabled','disabled');
        $.ajax({
          type: 'POST',
          url: this.savePaymentMethodsPath,
          data: {
            form_key: takhfifan.formKey,
            payment: {
              method: method
            }
          }
        }).done(function(data) {
          _this.paymentMethod = method;
          if(!data.error){
            _this.$('.tkh-travel-checkout__action-pay').removeAttr('disabled');
          }else{
            takhfifan.eventHub.trigger('message:show', {
              type: 'error',
              msg: 'خطا در ثبت درگاه پرداخت، درگاه پرداخت را انتخاب کنید'
            });
            takhfifan.eventHub.trigger('offline_passenger:error', 'save Payment Method:' + data.error);
          }
        }).fail(function (data) {
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: 'خطا در ثبت درگاه پرداخت، درگاه پرداخت را انتخاب کنید'
          });
          takhfifan.eventHub.trigger('offline_passenger:error', 'save Payment Method: connection');
        });
      },

      saveOrder: function () {
        this.disable();
        var _this = this;
        $.ajax({
          type: 'POST',
          url: '/ajax/onepage/saveOrder/',
          data: {
            form_key: takhfifan.formKey,
            payment: {
              method: this.paymentMethod
            }
           }
        }).done(function (data) {
          if (_.isEmpty(data.redirect) && data.success) {
            Lockr.set('travelHotelData', '');
            takhfifan.eventHub.trigger('travelPayment:success');
          } else if(data.redirect){
            Lockr.set('travelHotelData','');
            window.location.replace(data.redirect);
          }else{
            takhfifan.eventHub.trigger('message:show', {
              type: 'error',
              msg: 'عملیات با خطا مواجه شد.'
            });
            _this.showFailedCart('در برقراری ارتباط با سرور مشکلی پیش آمد. لطفا مجددا جستجو کنید');
            takhfifan.eventHub.trigger('offline_passenger:error', 'save order:' + (data.error_messages || 'unknown'));
          }
        }).fail(function () {
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: 'عملیات با خطا مواجه شد.'
          });
          _this.showFailedCart('در برقراری ارتباط با سرور مشکلی پیش آمد. لطفا مجددا جستجو کنید');
          takhfifan.eventHub.trigger('offline_passenger:error', 'save order:connection');
        }).complete(function(){
          _this.enable()
        });
      },
      enable: function(){
        this.$el.removeClass('loading-view');
      },

      disable: function(){
        this.$el.addClass('loading-view');
      },
    })
  });

